import { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Brand } from './AuthLayout.jsx';
import { Icon } from '../Icon.jsx';

export function AdminShell({ brand, navItems, onLogout, identityLabel }) {
  const [loggingOut, setLoggingOut] = useState(false);
  const [logoutError, setLogoutError] = useState(null);

  async function handleLogout() {
    setLoggingOut(true);
    setLogoutError(null);
    try {
      await onLogout();
    } catch (error) {
      setLogoutError(error.message || 'Could not log out. Please try again.');
      setLoggingOut(false);
    }
  }

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <Brand subtitle={brand} />
        <div className="sidebar__section">Workspace</div>
        <nav className="sidebar__nav" aria-label="Main navigation">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `sidebar__link${isActive ? ' active' : ''}`}
            >
              <Icon name={item.icon} />{item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar__account">
          {identityLabel && (
            <div className="sidebar__identity">
              <span className="sidebar__avatar" aria-hidden="true">{identityLabel.charAt(0).toUpperCase()}</span>
              <div>
                <strong>{brand}</strong>
                <span title={identityLabel}>{identityLabel}</span>
              </div>
            </div>
          )}
          {logoutError && <p className="sidebar__logout-error" role="alert">{logoutError}</p>}
          <button type="button" className="btn btn-ghost sidebar__logout" onClick={handleLogout} disabled={loggingOut} aria-busy={loggingOut || undefined}>
            <Icon name="logout" size={16} /> {loggingOut ? 'Logging out…' : 'Log out'}
          </button>
        </div>
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
